import CONSTANTS from '../constants';
import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';
import { getEntity } from '../utils';
import { formatZh, formatEnJa } from '../utils';

export default function useFormat(props) {

    const toolDateFormatter = new ToolDateFormatter({
        entity: getEntity()
    });

    function formatTime(timestamp) {
        return toolDateFormatter.dateFormatByTemplate({
            dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
            timestamps: timestamp * 1000,
            lang: props.contentLang
        });
    }

    function formatText(texts) {
        const showText = (texts || [])
            .map((text) => {
                if (+text.type === CONSTANTS.FEED_TYPE.TEXT) {
                    return `<span>${text.text || ''}</span>`;
                }
                if (+text.type === CONSTANTS.FEED_TYPE.TEXT_LINK) {
                    return `<span>${(text.textLink && text.textLink.text) || ''}</span>`;
                }
                if (+text.type === CONSTANTS.FEED_TYPE.STOCK && text.stockSymbol) {
                    return `<span>$${text.stockSymbol}$</span>`;
                }
                return '';
            })
            .join('')
            .trim();
        return showText;
    }

    function formatBrowseCountStr(browseCount) {
        const lang = CONSTANTS.LANG_LIST[props.contentLang];
        const unitStrMap = {
            'zh-cn': '万',
            'zh-hk': '萬'
        };
        const browseStrMap = {
            'zh-cn': '浏览',
            'zh-hk': '瀏覽',
            'en-us': 'Views',
            'ja': '閲覧'
        };

        if (['zh-cn', 'zh-hk'].includes(lang)) {
            return formatZh(browseCount, unitStrMap[lang], browseStrMap[lang]);
        }
        if (['en-us', 'ja'].includes(lang)) {
            return formatEnJa(browseCount, browseStrMap[lang]);
        }
        return browseCount;
    }

    return {
        formatTime,
        formatText,
        formatBrowseCountStr
    };
}
